function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  id: "canvas_background",
  height: 100,
  width: 100,
  y: -1,
  x: -1
}), /*#__PURE__*/React.createElement("g", {
  display: "none",
  overflow: "visible",
  y: 0,
  x: 0,
  height: "100%",
  width: "100%",
  id: "canvasGrid"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#gridpattern)",
  strokeWidth: 0,
  y: 0,
  x: 0,
  height: "100%",
  width: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
  ry: 48,
  rx: 48,
  id: "svg_1",
  cy: 48.75,
  cx: 48.75,
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "#56aaff"
}), /*#__PURE__*/React.createElement("ellipse", {
  ry: 9.749932,
  rx: 9.749932,
  id: "svg_2",
  cy: 48.749999,
  cx: 48.750009,
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "#ffffff"
}), /*#__PURE__*/React.createElement("line", {
  fillOpacity: 0,
  strokeDasharray: "5,5",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_3",
  y2: 38.88297,
  x2: 49.000001,
  y1: 1.22689,
  x1: 49.000001,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}));

var SvgMotor = function SvgMotor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMotor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/motor.555f1e30.svg";
export { ForwardRef as ReactComponent };